module.exports = __webpack_public_path__ + "static/media/pen.eb888e98.svg";